import React from "react"
import { Link, graphql } from 'gatsby'
import Layout from '../components/layout'
import Img from 'gatsby-image'
import Helmet from 'react-helmet'
import kebabCase from "lodash/kebabCase"

const AUTHOR_TWITTER = 'ryaneshea'

/*
import rehypeReact from 'rehype-react'

const renderAst = new rehypeReact({
  createElement: React.createElement,
}).Compiler*/

const Post = ({ data: { site, prismicPost } }) => {
  const { uid, data } = prismicPost

  const siteUrl = site.siteMetadata.siteUrl
  const authorTwitter = AUTHOR_TWITTER
  const postDescription = data.content.text.substring(0, 140)
  const postTitle = data.title.text
  const postUrl = `${siteUrl}/${uid}/`
  const postDate = data.date
  const postDateISO = new Date(postDate).toISOString().slice(0,10)

  const fluidImage = data.image.localFile.childImageSharp.fluid
  const postImage = fluidImage
  const postImageUrl = siteUrl + fluidImage.src
  const imageWidth = 800
  const imageHeight = fluidImage ? Math.round(imageWidth / fluidImage.aspectRatio) : imageWidth

  const tags = data.categories.map(category => category.category.uid)

  return (
    <Layout>
      <Helmet>
        <html lang="en" />
        <title>{postTitle}</title>
        <meta name="description" content={postDescription} />
        <meta name="image" content={postImageUrl} />
        <meta property="og:url" content={postUrl} />
        <meta property="og:type" content="article" />
        <meta property="og:title" content={postTitle} />
        <meta property="og:description" content={postDescription} />
        <meta property="og:image" content={postImageUrl} />
        <meta property="og:image:width" content={imageWidth} />
        <meta property="og:image:height" content={imageHeight} />
        <meta property="fb:app_id" content="2461607787452329" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:creator" content={authorTwitter} />
        <meta name="twitter:title" content={postTitle} />
        <meta name="twitter:description" content={postDescription} />
        <meta name="twitter:image" content={postImageUrl} />
      </Helmet>

      <article>
        <h1>{data.title.text}</h1>

        <p>
          <strong>
            <time dateTime={postDateISO}>{postDate}</time>
          </strong>

          <span> - </span>

          {tags.map((tag, index) => (
            <span key={index}>
              <Link to={`/category/${kebabCase(tag)}`}>
                {tag}
              </Link>
              { index !== tags.length-1 ?
                <span>, </span>
              : null }
            </span>
          ))}
        </p>

        { postImage ?
        <div className="mt-4 mb-4">
          <Img fluid={postImage} />
        </div>
        : null }

        <div dangerouslySetInnerHTML={{ __html: data.content.html }} />

      </article>
    </Layout>
  )
}


export default Post

export const pageQuery = graphql`
  query PostBySlug($uid: String!) {
    site {
      siteMetadata {
        title
        siteUrl
      }
    }
    prismicPost(uid: { eq: $uid }) {
      id
      uid
      data {
        date(formatString: "MMMM DD, YYYY")
        title {
          html
          text
        }
        content {
          html
          text
        }
        image {
          localFile {
            childImageSharp {
              fluid(maxWidth: 800) {
                ...GatsbyImageSharpFluid
              }
              fixed(width: 250, height: 250) {
                ...GatsbyImageSharpFixed
              }
            }
          }
        }
        categories {
          category {
            uid
          }
        }
      }
    }
  }
`